import { MultiPurposeParagraph } from "@/atoms/Paragraph";
import { FeaturedTitle, MultiPurposeTitle } from "@/components/Atoms/Title";
import { CustomUnderline, Underline } from "@/components/Atoms/Underline";

export const getGalleryTitleColor = (data: any) =>
  data.titleColor?.color || data.textColor?.color;

/** Image / section label captions — prefer CMS `labelColor`. */
export const getGalleryLabelColor = (data: any) =>
  data.labelColor?.color || getGalleryTitleColor(data);

export const getTitleLayout = (
  textAlignment?: string
):
  | "center"
  | "left"
  | "right"
  | "fixedCenter" => {
  if (textAlignment === "fixedCenter") return "fixedCenter";
  if (textAlignment === "center") return "center";
  if (textAlignment === "rigth" || textAlignment === "right") return "right";
  return "left";
};

export const getTextAlignmentItemClasses = (textAlignment?: string) => {
  if (textAlignment === "center" || textAlignment === "fixedCenter") {
    return "items-center mx-auto";
  }
  if (textAlignment === "rigth" || textAlignment === "right") {
    return "items-end ml-auto";
  }
  return "items-start";
};

export function GalleryHeader({
  data,
  showTitle = true,
  titleTag = "h3",
  TitleComponent = MultiPurposeTitle,
}: {
  data: any;
  showTitle?: boolean;
  titleTag?: "h3" | "h4";
  TitleComponent?: typeof MultiPurposeTitle | typeof FeaturedTitle;
}) {
  const hasLabel = data.addLabel && data.label;
  const hasTitle = showTitle && data.title;
  if (!hasLabel && !hasTitle) return null;

  return (
    <div
      className={`flex flex-col gap-4 w-fit max-w-full ${getTextAlignmentItemClasses(
        data.textAlignment
      )}`}
    >
      {hasLabel && (
        <MultiPurposeParagraph
          type="label"
          data={data.label}
          color={getGalleryLabelColor(data)}
        />
      )}
      {hasTitle && (
        <>
          <TitleComponent
            tag={titleTag}
            data={data.title}
            color={
              TitleComponent === FeaturedTitle
                ? data.textColor
                : getGalleryTitleColor(data)
            }
            layout={getTitleLayout(data.textAlignment)}
            {...(TitleComponent === MultiPurposeTitle
              ? { type: "default" as const }
              : {})}
          />
          {data.addTitleUnderline && (
            <>
              {data.customUnderlineAsset?.img ? (
                <CustomUnderline
                  shape={data.customUnderlineAsset?.img}
                  color={data.underlineColor?.color}
                />
              ) : (
                <Underline color={data.underlineColor?.color} />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}
